import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';

export const NAV_ITEM = [
  {
    routeName:'About Us',
    route:ROUTES.ABOUT_US,
    icon: Images.aboutUsIcon,
  },
  {
    routeName:'Contact Us',
    route:ROUTES.CONTACT_US,
    icon: Images.contactUsIcon,
  },
  // {
  //   routeName:'Hot Tours',
  //   route:ROUTES.HOT_TOURS,
  //   icon: Images.popularDestinations,
  // },
];

export const PRIVATE_NAV_ITEM = [
  {
    routeName:'Home',
    route:ROUTES.HOME,
    icon: Images.homeIcon,
  },
  {
    routeName:'How it works',
    route:ROUTES.HOW_ITS_WORK,
    icon: Images.howItWorkIcon,
  },
  {
    routeName:'Requests',
    route:ROUTES.REQUESTS,
    icon: Images.requestIcon,
  },
  // {
  //   routeName:'Favorites',
  //   route:ROUTES.FAVORITES,
  //   icon: Images.favoriteIcon,
  // },
  {
    routeName:'Settings',
    route:ROUTES.SETTINGS,
    icon: Images.settingsIcon,
  },
];
